import JournalHome from './Journal';

export default JournalHome;
